/**
 * @file Basic Controller
 */

'use strict';
import ApplyClass from '../Utils/ApplyClass';
import Listener from '../Utils/Listener';
import BasicModel from '../Model/BasicModel';
import Common  from '../Utils/Common';
import Template from '../Template/Template';
import GetChildCategories from '../View/Basic/GetChildCategories';
import Swiper from '../View/Basic/Swiper';

let instance = null;

/**
 * @classname Basic
 * @classdesc Basic Controller
 */
export default class Basic {

	/**
	 * @constructor
	 */
	constructor() {
		if (instance) {
			return instance;
		}
		console.log('Basic.constructor');

		this._model = new BasicModel();

		this._listener = new Listener();

		this._itemId = null;
		this._itemStockId = null;

		this._model.on('onFavoriteComplete', () => {
			this._listener.trigger('onFavoriteComplete');
		});
		this._model.on('onGetChildCategoriesComplete', () => this.createChildCategories());
		this._model.on('onGetChildCategoriesSpComplete', () => this.createChildCategoriesSp());
		this._model.on('onAddCartComplete', () => {
			location.href = window.const.URL.CART;
		});
		this._model.on('onChangeCartQuantityComplete', () => {
			location.reload();
		});
		this._model.on('onCartDeleteComplete', () => {
			location.reload();
		});
		this._model.on('onApplyCouponComplete', () => {
			this._data = this._model._data;
			this._listener.trigger('onApplyCouponComplete');
		});
		this._model.on('onApplySelectedCouponComplete', () => {
			this._data = this._model._data;
			this._listener.trigger('onApplySelectedCouponComplete');
		});
		this._model.on('wrongCouponCode', () => {
			this._message = this._model._message;
			this._listener.trigger('wrongCouponCode');
		});
		this._model.on('onReCalculateComplete', () => {
			this._data = this._model._data;
			this._listener.trigger('onReCalculateComplete');
		});
		this._model.on('onReCalculateCartComplete', () => {
			this._data = this._model._data;
			location.reload();
			//this._listener.trigger('onReCalculateCartComplete');
		});
		this._model.on('onApplySelectedCouponError', () => {
			this._listener.trigger('onApplySelectedCouponError');
		});
		this._model.on('onError', () => {
			this._listener.trigger('onError');
		});

		instance = this;
		return instance;
	};


	/**
	 * お気に入り
	 *
	 * @memberof Basic
	 * @param {string} itemId - 商品ID
	 * @param {boolean} flg - 登録フラグ
	 * @return {undefined}
	 */
	favorite(itemId, flg) {
		console.log(`Basic.favoriteOn: itemId: ${itemId}`);
		this._itemId = itemId;
		this._model.favorite(itemId, flg);
	};


	/**
	 * 子カテゴリー取得
	 *
	 * @memberof Basic
	 * @param {string} categoryId - カテゴリーID
	 * @param {number} level - カテゴリー階層レベル
	 * @return {undefined}
	 */
	getChildCategories(categoryId, level) {
		console.log(`Basic.getChildCategories/ categoryId: ${categoryId}/ level: ${level}`);
		this._categoryLevel = level;
		this._model.getChildCategories(categoryId, level);
	};


	/**
	 * カテゴリー作成(PC)
	 *
	 * @memberof Basic
	 * @return {undefined}
	 */
	createChildCategories() {
		console.log(`Basic.createChildCategories`);
		const categories = this._model._data;
		const html = Template.CreateCategories(categories, this._categoryLevel);
		if(this._categoryLevel === 1) {
			$('.input-select__select[name=cat2]').parent('.input-select').remove();
			$('.input-select__select[name=cat3]').parent('.input-select').remove();
			$('.form-group__content--category').append(html);
			const $e = $('.form-group__content--category .cat2');
			$('.cat2').each((idx, e) => {
				const $e = $(e);
				ApplyClass.apply(GetChildCategories, $e, [$e, this]);
			})
			this._categoryLevel = null;
		}else if(this._categoryLevel === 2) {
			$('.input-select__select[name=cat3]').parent('.input-select').remove();
			$('.form-group__content--category').append(html);
		}
	};


	/**
	 * カートに追加
	 *
	 * @memberof Basic
	 * @return {undefined}
	 */
	AddCart() {
		console.log(`Basic.AddCart`);
		console.log(`stockId: ${this._itemStockId}`);
		this._model.AddCart(this._itemStockId);
	};


	/**
	 * swiper適応
	 *
	 * @memberof Basic
	 * @return {undefined}
	 */
	setSwiper() {
		console.log(`Basic.setSwiper`);
		const $e = $('.swiper--current-viewed');
		ApplyClass.apply(Swiper, $e, [$e]);
	};


	/**
	 * カート数量変更
	 *
	 * @memberof Basic
	 * @param {string} itemStockId - 在庫ID
	 * @param {string} quantity - 数量
	 * @return {undefined}
	 */
	ChangeCartQuantity(itemStockId, quantity) {
		console.log(`Basic.ChangeCartQuantity`);
		this._itemStockId = itemStockId;
		this._model.ChangeCartQuantity(itemStockId, quantity);
	};


	/**
	 * カート商品削除
	 *
	 * @memberof Basic
	 * @param {string} stockId - 在庫ID
	 * @return {undefined}
	 */
	CartDelete(stockId) {
		console.log(`Basic.ChangeCartQuantity`);
		this._model.CartDelete(stockId);
	};


	/**
	 * 売り切れ処理
	 *
	 * @memberof Basic
	 * @return {undefined}
	 */
	soldOut(itemId) {
		console.log(`Basic.soldOut`);
		$('.image-box--item-detail.image-box--main').addClass('sold-out');
	};


	/**
	 * 売り切れ処理取り消し
	 *
	 * @memberof Basic
	 * @return {undefined}
	 */
	notSoldOut() {
		console.log(`Basic.notSoldOut`);
		$('.image-box--item-detail.image-box--main').removeClass('sold-out');
	};


	/**
	 * クーポン適用
	 *
	 * @memberof Basic
	 * @param {string} couponCode - クーポンコード
	 * @return {undefined}
	 */
	applyCoupon(couponCode) {
		console.log(`Basic.ApplyCoupon`);
		this._model.applyCoupon(couponCode);
	};


	/**
	 * 選択クーポン適用
	 *
	 * @memberof Basic
	 * @param {string} couponId - クーポンID
	 * @return {undefined}
	 */
	applySelectedCoupon(couponId) {
		console.log(`Basic.applySelectedCoupon`);
		this._model.applySelectedCoupon(couponId);
	};


	/**
	 * 再計算
	 *
	 * @memberof Basic
	 * @param {string} couponCode - クーポンコード
	 * @return {undefined}
	 */
	reCalculate(couponId = null, isSelectedCoupon = false) {
		console.log(`Basic.reCalculate`);
		this._model.reCalculate(couponId,isSelectedCoupon);
	};


	/**
	 * listener on
	 *
	 * @memberof Basic
	 * @param {string} name - イベント名
	 * @param {function} fn - 実行する関数
	 * @return {undefined}
	 */
	on(name, fn) {
		this._listener.on(name, fn);
	};


	/**
	 * listener off
	 *
	 * @memberof Basic
	 * @param {string} name - イベント名
	 * @param {function} fn - 実行する関数
	 * @return {undefined}
	 */
	off(name, fn) {
		this._listener.off(name, fn);
	};
}
